import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const playerToken = {
  key: (slug) => `arenafy_pt_${slug}`,
  get: (slug) => localStorage.getItem(`arenafy_pt_${slug}`),
  set: (slug, t) => localStorage.setItem(`arenafy_pt_${slug}`, t),
  clear: (slug) => localStorage.removeItem(`arenafy_pt_${slug}`),
};

export const playerApi = (slug) =>
  axios.create({ baseURL: API, headers: { "X-Player-Token": playerToken.get(slug) || "" } });

export const wsUrl = (path) => `${BACKEND_URL.replace(/^http/, "ws")}${path}`;
